import React from 'react';

import styles from './styles.module.scss';

const Price = ({ price, timeUnit }) => (
  <div className={styles.pricingContainer}>
    <div className={styles.pricingContent}>
      <div className={styles.price}>£{price}</div>
    </div>
    <div className={styles.description}>Per {timeUnit} excl VAT</div>
  </div>
);

export default Price;
